import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth, type SessionUser } from "@/auth";
import { PageError, PageLoading } from "@/components/page-state";

export function RequireAuth({ children, roles }: { children: ReactNode; roles?: SessionUser["role"][] }) {
  const { user, loading } = useAuth();
  if (loading) return <PageLoading />;
  if (!user) return <Navigate to={`/signin?next=${encodeURIComponent(window.location.pathname + window.location.search)}`} replace />;
  if (roles && !roles.includes(user.role)) return <PageError title="Access denied" />;
  return children;
}
